export const SERVICE_NAMES: Record<string, string> = {
  AccountManagement: 'Account Management',
  AccountSearch: 'Search',
  Agents: 'Agent Engine',
  Application: 'Workspace',
  Automation: 'Automations',
  Billing: 'Billing',
  Bridge: 'Desktop Bridge',
  CloudFilesystem: 'Cloud Filesystem',
  Context: 'Context',
  Indexing: 'Indexing',
  Integrations: 'Connections',
  Persona: 'Persona',
  Reasoning: 'Reasoning',
  Sessions: 'Sessions',
  Tools: 'Tools',
  WorkManagement: 'Work Management',
  temporal: 'Temporal',
};

const ERROR_MESSAGES: Record<string, string> = {
  ACCOUNT_SEARCH_INDEX_FAILED: 'Failed to update search index',
  AUTOMATION_DISPATCH_FAILED: 'Failed to dispatch automation',
  BILLING_USAGE_RECORD_FAILED: 'Failed to record usage',
  ENTITLEMENT_CHECK_FAILED: 'Feature access check failed',
  DEFAULT_TEAM_CREATION_FAILED: 'Failed to create default team',
  SANDBOX_POD_CLEANUP_FAILED: 'Failed to clean up sandbox',
  PM_EVALUATION_FAILED: 'PM evaluation failed',
  STALENESS_CHECK_FAILED: 'Staleness check failed',
  TEMPORAL_RPC_ERROR: 'Service communication error',
  TEMPORAL_TIMEOUT: 'Operation timed out',
  TEMPORAL_CANCELLED: 'Operation was cancelled',
  TEMPORAL_TERMINATED: 'Operation was terminated',
  WORKFLOW_FAILURE: 'Workflow failed',
  TEMPORAL_SERVER_ERROR: 'Temporal server error',
  TEMPORAL_ACTIVITY_FAILED: 'Activity failed',
};

export function resolveErrorMessage(errorCode: string, rawMessage: string): string {
  return ERROR_MESSAGES[errorCode] ?? rawMessage;
}

export function resolveServiceName(serviceOrigin: string): string {
  return SERVICE_NAMES[serviceOrigin] ?? serviceOrigin;
}
